import * as util from "../../../common/m_base/util"
import { override } from 'core-decorators'

import {RewardJsToggleCloseBtnShow, VideoBridgeToggleBouncesOff} from "@api";
import {getUrlParams} from "@src/common/util";

import {
    getEndScreenInfo,
} from "../../../api/index";
import Webview from "../../component/native/visible/Webview"
import Slot from "../../component/template/Slot";
import IframeView from "../../component/visible/Container"
import {getFilePathByRemoteUrl} from '@src/common/util'
//import OldVideoDemo from "../rv/OldVideoDemo/index";
import MultipleOfferTemplate from "../../component/template/MultipleOfferTemplate";
import App from "../../../class/App";

/**
 * mintegral SDK 大模板
 */
export default class IframeBtDemo extends MultipleOfferTemplate {
    constructor(props = {}) {
        super(props);

        //this.templateName = props.templateName || 'mtg_btDemo_template'


        (function(){
            let timer = 1;
            window.addEventListener('message', (e)=>{
                console.log("iframe 获取到 message====>",e, location.href)
                const {action, data} = e.data
                if(action==='subClick'){
                    document.getElementById('msg').innerHTML += (data+' '+timer+'<br/>')
                    timer++
                }
            })
        })();


    }

    show() {
        super.show()
        console.log('im show')
    }

    initComponents() {
        super.initComponents()

        //this.container.setAlpha(0.9)
        //this.container.setBG({ "color":"#ff0000"})
        //this.subTpl = new Container()
        this.subTpl = new IframeView()
        this.subTpl2 = new IframeView()
        //console.log('this.subTpl  this.subTpl ', this.subTpl )

        //this.subTpl.setBG({ "color":"#224466"})
        //this.subTpl2.setBG({ "color":"#ff0000"})

        //this.subTpl.appendTo(this.container)
        //this.subTpl2.appendTo(this.container)
        //this.container.append(this.subTpl2)


        console.log('ifr==>')

        document.body.addEventListener('touchstart', (e)=>{
            console.log('ifr==>')
            let ifr = this.subTpl.getElement()
            console.log('ifr==>', ifr, ifr.contentWindow, ifr.contentWindow.postMessage)
            ifr.contentWindow.postMessage({
                action: 'mofClick',
                data: {
                    msg: '向子模版1发送消息',
                    initData: App.initData,
                },
            }, '*')
            let ifr2 = this.subTpl2.getElement()
            ifr2.contentWindow.postMessage({
                action: 'mofClick',
                data: {
                    msg: '向子模版2发送消息',
                    initData: App.initData
                },
            }, '*')
        }, false)




        console.log('+++++-获取到load campaign参数：', this.campaignList)

        //let templateUrl = 'http://192.168.1.124:3000/singleVideoDemo/singleVideoDemo.html'
        let campaign = this.campaignList[0]
        let campaign2 = this.campaignList[1] || this.campaignList[0]
        let subTplURL = campaign && campaign.rv && campaign.rv.template_url
        let subTpl2URL = campaign && campaign.rv && campaign.rv.template_url
        //let subTpl2URL = campaign2 && campaign2.rv && campaign2.rv.template_url

        subTplURL+= '&createByIframe=true'
        subTpl2URL+= '&createByIframe=true'

        //let subTplURL = 'http://192.168.4.156:3000/iframeSingleDemo/iframeSingleDemo.html?createByIframe=true'
        //let subTpl2URL = 'http://192.168.4.156:3000/iframeSingleDemo/iframeSingleDemo.html?createByIframe=true'

        console.log('------获取到load campaign参数：', subTplURL)
        /*Webview.getLoadCampaignParams(subTplURL, [campaign], this.unit.id, this.unit.setting)
            .then(loadParams=>{
                console.log('获取到load campaign参数：', loadParams)
                //this.subTpl2.load(loadParams)
                this.subTpl.load(loadParams)
                /!* this.subTpl.whenCampaignReady().then(()=>{
                     console.log('whenCampaignReady')
                 }).catch(()=>{
                     console.log('whenCampaignReady !')
                 })*!/
            })
        Webview.getLoadCampaignParams(subTpl2URL, [campaign2], this.unit.id, this.unit.setting)
            .then(loadParams=>{
                this.subTpl2.load(loadParams)
            })*/

        IframeView.getLoadCampaignParams(subTplURL, [campaign], this.unit.id, this.unit.setting, App.initData)
            .then(loadParams=>{
                console.log('获取到load campaign参数：', loadParams)
                this.subTpl.load(loadParams)
            })
        IframeView.getLoadCampaignParams(subTpl2URL, [campaign2], this.unit.id, this.unit.setting, App.initData)
            .then(loadParams=>{
                this.subTpl2.load(loadParams)
            })




    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
        this.container.onAppend(event=>{
            console.log('onAppend', event)
        })
        this.container.onAppendTo(event=>{
            console.log('onAppendTo', event)
        })
        this.container.onBgColorChanged(event=>{
            console.log('onBgColorChanged', event)
        })
        this.container.onLoad(event=>{
            console.log('onWebviewLoad', event)
        })
        this.container.onClicked(event=>{
            console.log('onClicked', event)
        })
    }
    /**
     * 初始化插槽
     */
    initSlots(){
        super.initSlots()
        this.slotIn('slot_1', this.subTpl)
        this.slotIn('slot_2', this.subTpl2)
        //this.slotInBelow('slot_2', this.subTpl2)

        /*const query = getUrlParams()
        console.log('query.insertBelow ====> ', query,query.insertBelow,query.insertBelow === 'true')
        if(query.insertBelow === 'true'){
            console.log('insertBelow 1')
            this.slotInBelow('slot_2', this.subTpl2)
        }else{
            console.log('insertBelow 2')
            this.slotIn('slot_2', this.subTpl2)
        }*/
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return Promise.all([
            super._isLoadFinish(),
            this.subTpl.whenCampaignReady(),
            // this.subTpl2.whenCampaignReady()
        ])
    }

}